export const userRoleOptions = [
  {
    id: 'ROLE_TRANSLATIONS_MANAGER',
    name: 'Translations manager',
    option: 'Translations manager',
    value: 'ROLE_TRANSLATIONS_MANAGER',
  },
  {
    id: 'ROLE_CLIENTS_MANAGER',
    name: 'Clients manager',
    option: 'Clients manager',
    value: 'ROLE_CLIENTS_MANAGER',
  },
  {
    id: 'ROLE_ADMIN',
    name: 'Admin',
    option: 'Admin',
    value: 'ROLE_ADMIN',
  },
  {
    id: 'ROLE_DEVELOPER',
    name: 'Developer',
    option: 'Developer',
    value: 'ROLE_DEVELOPER',
  },
];

export const getRoleNamesByIds = (ids) => {
  if (!Array.isArray(ids) || ids.length === 0) return '--';
  return ids
    .map((id) => {
      const role = userRoleOptions.find((option) => option.id === id);
      return role ? role.name : id;
    })
    .join(', ');
};

/** @deprecated use getRoleNamesByIds */
export const getRoleNameById = (id) => getRoleNamesByIds(Array.isArray(id) ? id : [id]);
